module.exports = __webpack_public_path__ + "img/descubre-marca1.1755c124.png";